<template>
  <div class="landing_background">
    <AppRequirementCheck></AppRequirementCheck>
    <div id="lockholder"></div>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import { AUTH0_CALLBACK } from "@/common/config";
import { login, isLoggedIn } from "@/common/authenticate";
import { getPreferredLandingPage } from "@/services/user/user.service";
import router from "@/router";

export default {
  name: "Landing",
  components: {
    AppRequirementCheck: () =>
      import("@/components/common/AppRequirementCheck"),
  },
  async mounted() {
    let loggedIn = await isLoggedIn();

    let registrationToken = lodashGet(this, "$route.query.registration_token");
    let allowRegistration = await this.allowRegistration(registrationToken);
    let signup = !!lodashGet(this, "$route.query.signup");

    let initialScreen = lodashGet(this, "$route.query.initialScreen");
    if (signup && allowRegistration) {
      initialScreen = "signUp";
    }

    let redirect = lodashGet(this, "$route.query.redirect");

    if (!loggedIn || allowRegistration) {
      let options = {};
      if (allowRegistration) {
        options.registration_token = escape(registrationToken);
        options.showRegistration = true;
      }
      if (initialScreen) {
        options.initialScreen = initialScreen;
      }
      if (redirect) {
        options.redirect_uri = `${AUTH0_CALLBACK}?redirect=${redirect}`;
      }
      await login({ authorizationParams: options });
    } else {
      if (redirect) {
        router.push({ path: this.$route.query.redirect });
      } else {
        router.push({ name: getPreferredLandingPage() });
      }
    }
  },
  methods: {
    allowRegistration: async (given_token) => {
      return !!given_token && typeof given_token === "string";
    },
  },
};
</script>

<style scoped>
.landing_background {
  background: #191a1a;
  height: 100%;
}
#lockholder {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
</style>
